import z from 'zod';
import { CognitoUserIdSchema, UUIDSchema, UnixTimestampSchema } from '../common/schemas';
import { DBJsonObjectSchema, DBTimestampSchema, JsonObjectSchema } from '../common/sql';
import {
  DBQuestionDigitisationRunCountSchema,
  DBQuestionDigitisationRunFaultSchema,
  DBQuestionDigitisationRunModelSchema,
  DBQuestionDigitisationRunNoteSchema,
  DBQuestionDigitisationRunStatusDetailSchema,
  DBQuestionDigitisationRunStatusSchema,
  QuestionDigitisationRunCountSchema,
  QuestionDigitisationRunFaultSchema,
  QuestionDigitisationRunModelSchema,
  QuestionDigitisationRunStatusDetailSchema,
  QuestionDigitisationRunStatusSchema,
} from '../questionDigitisationRuns/schemas';

/**
 * DB Schemas
 */

export const DBImageDigitisationRunIdSchema = UUIDSchema;

export const DBImageDigitisationRunSchema = z.object({
  id: DBImageDigitisationRunIdSchema,
  assetId: UUIDSchema,
  subjectId: UUIDSchema,
  requestedBy: CognitoUserIdSchema,
  handwrittenAnswers: z.boolean(),
  note: DBQuestionDigitisationRunNoteSchema,
  model: DBQuestionDigitisationRunModelSchema,
  status: DBQuestionDigitisationRunStatusSchema,
  statusDetail: DBQuestionDigitisationRunStatusDetailSchema,
  reclaims: DBQuestionDigitisationRunCountSchema,
  faults: z.array(DBQuestionDigitisationRunFaultSchema),
  stats: DBJsonObjectSchema.nullable(),
  createdRootQuestionIds: z.array(UUIDSchema),
  startedAt: DBTimestampSchema.nullable(),
  finishedAt: DBTimestampSchema.nullable(),
  createdAt: DBTimestampSchema,
  updatedAt: DBTimestampSchema.nullable(),
});

/**
 * Client Schemas
 */

export const ImageDigitisationRunIdSchema = DBImageDigitisationRunIdSchema.openapi({
  description: 'A reading of a picture of one question',
});
export const ImageDigitisationRunHandwrittenAnswersSchema = z.boolean().openapi({
  description: 'Whether a choice ticked or circled by hand in the picture is the correct one',
  example: false,
});
export const ImageDigitisationRunNoteSchema = DBQuestionDigitisationRunNoteSchema.openapi({
  description: 'What the person who sent the picture wrote for the model',
  example: 'The diagram is the one on the left.',
});

export const ImageDigitisationRunSchema = z.object({
  id: ImageDigitisationRunIdSchema,
  assetId: UUIDSchema.openapi({ description: 'The picture, as a PNG' }),
  subjectId: UUIDSchema.openapi({ description: 'The subject its questions are filed under' }),
  requestedBy: CognitoUserIdSchema.openapi({ description: 'Who sent the picture' }),
  handwrittenAnswers: ImageDigitisationRunHandwrittenAnswersSchema,
  note: ImageDigitisationRunNoteSchema,
  model: QuestionDigitisationRunModelSchema,
  status: QuestionDigitisationRunStatusSchema,
  statusDetail: QuestionDigitisationRunStatusDetailSchema,
  reclaims: QuestionDigitisationRunCountSchema,
  faults: z.array(QuestionDigitisationRunFaultSchema),
  stats: JsonObjectSchema.nullable(),
  createdRootQuestionIds: z.array(UUIDSchema).openapi({
    description: 'The questions the reading wrote, once it has',
  }),
  startedAt: UnixTimestampSchema.nullable(),
  finishedAt: UnixTimestampSchema.nullable(),
  createdAt: UnixTimestampSchema,
  updatedAt: UnixTimestampSchema.nullable(),
});
